<template>
	<div class="lab-list">
		<div v-for="(lab,index) in labs" :key="index" class="lab-item" @click="toOrder(lab.id)">
		  <div class="lab-icon" :style="'background-image: url(/static/lab/icon-' + lab.icon + ');'"></div>
		  <div class="lab-name">{{lab.name}}</div>
		  <van-icon class="icon" name="arrow" size="40" />
		</div>
	</div>
</template>

<script>
	import { getLabList } from '@/api'
	export default {
	  name: "LabList",
	  data() {
	  	return {
	  		labs: []
	  	}
	  },
	  mounted() {
	  	this.getLabList()
	  },
	  methods: {
	  	toOrder(labId) {
	  		this.$router.push({
	  			name: 'getOrder',
	  			query: {
	  				labId
	  			}
	  		})
	  	},
	  	getLabList() {
	      getLabList({
	        status: '1'
	      }).then(res => {
	        if (res) {
	          this.labs = res.map(item => {
	            return {
	              name: item.name,
	              id: item.id,
	              icon: item.icon
	            }
	          })
	        }
	      })
	    },
	  }
	}
</script>

<style lang="scss" scoped>
	body {
		height: 100vh;
		background-color: rgb(33, 174, 195);
	}
	.lab-list{
		margin: 0 auto;
		width: 700px;
		text-align: center;
		.lab-item {
			position: relative;
			width: 700px;
			height: 104px;
			margin: 30px auto;
			background-color: rgb(211, 239, 243);
			box-shadow: 0 0 2px rgb(33, 174, 195);
			display: flex;
			align-items: center;
			.lab-icon {
				width: 120px;
				height: 40px;
				margin: 20px;
				background-size: 120px 40px;
				background-position: center;
				background-repeat: no-repeat;
			}
			.lab-name{
				padding-left: 20px;
				font-size: 32px;
				font-weight: bold;
			}
			.icon {
				position: absolute;
				right: 0;
				color: rgb(33, 174, 195);
			}
		}
	}
</style>
